<div id="component-container-ys-{{ component?.id }}"
  class="component-container component-container-{{ component.type }}"
  [hidden]="playerService.getComponentHidden(component, content)" style="width:{{ component.width }}px;height:{{ component.height }}px;
  top:{{ component.draggable ? '0' : component.pos.y }}px;left:{{
    component.draggable ? '0' : component.pos.x
  }}px;z-index:{{ !statesService.getComponentState(component) ? component.style.zIndex : statesService.getComponentState(component).style.zIndex}};{{
    component.style.transition ? 'transition:' + component.style.transition : ''
  }}" [ngClass]="{ 'bring-to-front': component.style?.hoverEffect?.bringToFront }"
  (mouseleave)="onMouseleave(component)" [ngStyle]="
              component
                | componentContainerStyle  : playMotionPath : stringify(component) : stringify(playMotionPath)
            ">
  <div class="block-transform" [ngStyle]="
      component
        | blockStyle
          : content
          : contentService.stringify(
              playerService.getComponentBlock(component, content)
            ) : null
            : 'player'
    "
    style="z-index:{{ !statesService.getComponentState(component) ? component.style.zIndex : statesService.getComponentState(component).style.zIndex }};">
    <div class="block-animation" id="block-component-{{ component.id }}" [ngClass]="
        component
          | blockAnimation
            : content
            : contentService.stringify(
                playerService.getComponentBlock(component, content)
              )
      ">
      <!-- popover -->
      <ng-template #popTemplate>
        <app-popover [scenario]="scenario" [component]="component"></app-popover>
      </ng-template>
      <!-- end popover -->

      <div class="component-wrap component-wrap-{{ component.type }}" id="component-wrap-ys-{{ component.id }}"
        [ngStyle]="
              component
                | componentWrapStyle  : stringify(component)
            " [popover]="
          component?.interactivity?.popover?.content?.body ||
          component?.interactivity?.popover?.content?.image ||
          component?.interactivity?.popover?.content?.video
            ? popTemplate
            : ''
        " [popoverTitle]="
          component?.interactivity?.popover?.template?.title &&
          component?.interactivity?.popover?.content?.title
            ? component?.interactivity?.popover?.content?.title
            : ''
        " container="body" triggers="{{
          component?.interactivity?.popover?.template?.trigger
            ? component?.interactivity?.popover?.template?.trigger
            : 'click'
        }}" containerClass="scenario-ui-{{ scenario?.id }} ys-popover-{{
          component.id
        }} ys-popover {{
          !component?.interactivity?.popover?.template?.title
            ? 'ys-popover-no-title'
            : ''
        }}">
        <div [ngClass]="{
            'component-image-shadow': component.style?.imageCrop?.clip
          }">
          <ng-template #tooltipTemplate>
            <div [innerHtml]="
                component?.interactivity?.tooltip?.content
                  ? (component?.interactivity?.tooltip?.content
                    | scenarioVars : scenarioVars)
                  : (component?.data?.tooltip | scenarioVars : scenarioVars)
              "></div>
          </ng-template>
          <div id="component-ys-{{ component?.id }}" [tooltip]="tooltipTemplate ? tooltipTemplate : ''" triggers="{{
              !component?.interactivity?.tooltip?.content &&
              !component?.data?.tooltip
                ? ''
                : 'hover'
            }}" containerClass="scenario-ui-{{ scenario?.id }} ys-tooltip" [adaptivePosition]="true" container="body"
            [ngSwitch]="component.type" class="component component-{{ component.type }}" [ngStyle]="
              component
                | componentStyle : 'player' : scenario : stringify(component)
            " [ngClass]="
              component
                | componentClass : 'player' : scenario : stringify(component)
            " (click)="playerService.onComponentPressed(component)"
            (keyup.enter)="playerService.onComponentPressed(component)"
            (dblclick)="playerService.onComponentDoublePressed(component)"
            (mouseenter)="playerService.onComponentHovered(component)"
            (mouseleave)="playerService.onComponentHoverOut(component)" [style.clipPath]="
              component.type == 'image' && contentService.getImageClip(component)
                ? contentService.getImageClip(component)
                : null
            " [attr.tabindex]="
              playerService.isActiveComponent(component) ? 0 : null
            ">
            <ng-container *ngSwitchCase="'blank'">
              <app-blank-component [component]="component"></app-blank-component>
            </ng-container>
            <ng-container *ngSwitchCase="'text'">
              <app-text-component [component]="component"
                [htmlString]="(statesService.getComponentState(component) ? statesService.getComponentState(component).content : component.content) | scenarioVars : scenarioVars"></app-text-component>
              <!--app-text-component *ngIf="statesService.getComponentState(component)" [component]="component"
                [htmlString]="statesService.getComponentState(component).content | scenarioVars : scenarioVars"></app-text-component-->
            </ng-container>
            <ng-container *ngSwitchCase="'sr'">
              <div class="visually-hidden" [innerHtml]="component.content | scenarioVars : scenarioVars"></div>
            </ng-container>
            <ng-container *ngSwitchCase="'image'">
              <app-image-component [component]="component"></app-image-component>
            </ng-container>
            <ng-container *ngSwitchCase="'chat'">
              <app-chat-component *ngIf="
                  !component?.data?.format ||
                  component?.data?.format == 'classic'
                " [component]="component"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-chat-component>
              <app-chat-messenger-component *ngIf="component?.data?.format == 'messenger'" [component]="component"
                [mode]="'player'"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-chat-messenger-component>
              <app-chat-adventure-component *ngIf="component?.data?.format == 'adventure'" [component]="component"
                [mode]="'player'"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-chat-adventure-component>
            </ng-container>
            <ng-container *ngSwitchCase="'quiz'">
              <app-quiz-component [component]="component"
                (activityEnded)="playerService.onActivityEnded($event, content)" [mode]="'player'"></app-quiz-component>
              <!--app-quiz-gameshow
              [component]="component"
              (activityEnded)="playerService.onActivityEnded($event, content)"
            ></app-quiz-gameshow-->
            </ng-container>

            <ng-container *ngSwitchCase="'form'">
              <app-form-component [component]="component"
                (activityEnded)="playerService.onActivityEnded($event, content)"
                [scenario]="scenario"></app-form-component>
            </ng-container>

            <ng-container *ngSwitchCase="'table'">
              <app-table-component [component]="component"></app-table-component>
            </ng-container>

            <ng-container *ngSwitchCase="'button'">
              <app-button-component [component]="component"></app-button-component>
            </ng-container>

            <ng-container *ngSwitchCase="'download'">
              <app-download-component [component]="component"></app-download-component>
            </ng-container>

            <ng-container *ngSwitchCase="'hotspot'">
              <app-hotspot-component [component]="component" [scenario]="scenario"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-hotspot-component>
            </ng-container>

            <ng-container *ngSwitchCase="'360'">
              <app-panoramic-image-component [component]="component"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-panoramic-image-component>
            </ng-container>

            <ng-container *ngSwitchCase="'model'">
              <app-model-component [component]="component" [mode]="'player'"></app-model-component>
            </ng-container>

            <ng-container *ngSwitchCase="'pick'">
              <app-pick-task [component]="component"
                (activityEnded)="playerService.onActivityEnded($event, content)"></app-pick-task>
            </ng-container>
            <ng-container *ngSwitchCase="'video'">
              <app-video-component [component]="component" [content]="content" [muted]="muted"
                [disableVideo]="disableVideo"></app-video-component>
            </ng-container>
            <ng-container *ngSwitchCase="'audio'">
              <app-audio-component [component]="component" [content]="content" [muted]="muted"
                [disableAudio]="disableAudio"></app-audio-component>
            </ng-container>
            <ng-container *ngSwitchCase="'shape'">
              <app-shape-component [component]="component"></app-shape-component>
            </ng-container>

            <ng-container *ngSwitchCase="'icon'">
              <app-icon-component [component]="component"></app-icon-component>
            </ng-container>
            <ng-container *ngSwitchCase="'drawing'">
              <svg class="drawing" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none"
                width="100%" height="100%" [attr.viewBox]="component.viewbox"
                [attr.aria-describedby]="component.id + '-desc'">
                <title *ngIf="component.data?.description">
                  {{ component.data?.description }}
                </title>
                <desc *ngIf="component.data?.description" id="{{ component.id }}-desc">
                  {{ component.data?.description }}
                </desc>
                <path [attr.d]="pathData" *ngFor="let pathData of component.content" />
              </svg>
            </ng-container>
            <ng-container *ngSwitchCase="'chart'">
              <app-chart-component [component]="component" [scenario]="scenario"
                [mode]="'player'"></app-chart-component>
            </ng-container>
            <ng-container *ngSwitchCase="'embed'">
              <app-embed-component [component]="component">
              </app-embed-component>
            </ng-container>


            <ng-container *ngSwitchCase="'progress'">
              <app-progress-component [component]="component">
              </app-progress-component>
            </ng-container>

            <ng-container *ngSwitchCase="'timer'">
              <app-timer-component [component]="component">
              </app-timer-component>
            </ng-container>

            <ng-container *ngSwitchCase="'tabs'">
              <app-tabs-component [component]="component"> </app-tabs-component>
            </ng-container>
            <ng-container *ngSwitchCase="'choices'">
              <app-choices-component [component]="component" [step]="step"
                [scenario]="scenario"></app-choices-component>
            </ng-container>
            <ng-container *ngSwitchCase="'choice'">
              <div class="single-choice-container">
                <button class="choice" (click)="playerService.onChoice(component.data.choice, step)"
                  [ngClass]="contentService.getChoiceClass(component)"
                  [hidden]="playerService.checkChoice(component.data.choice)" tabindex="0" type="button">
                  <div *ngIf="component.data.choice.media && component.data.choice.media.url">
                    <img src="{{ component.data.choice?.media?.url }}"
                      alt="Image for choice `{{ component.data.choice.title }}`" style="max-height: 150px"
                      class="rounded-3" />
                  </div>
                  <i class="bx {{ component.data.choice.icon }}" *ngIf="component.data.choice.icon"
                    [ngClass]="{ 'me-1': !component.data.choice?.config?.hideText }"></i>
                  <ng-container *ngIf="!component.data.choice?.config?.hideText">{{
                    component.data.choice.title
                    }}</ng-container>

                  <span *ngIf="component.data.choice?.config?.hideText" class="visually-hidden">{{
                    component.data.choice.title }}</span>
                </button>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'yo-logo'">
              <a href="https://www.yoscenario.com" target="_blank">
                <span class="visually-hidden">Yo Scenario logo</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.18 215.18">
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                      <path class="cls-1"
                        d="M168.51 112.31a64.33 64.33 0 0 1-6.64-11.58 84.3 84.3 0 0 0-6.49-11.87 3.92 3.92 0 0 1-1.18 1.47c-.59.49-1.23.4-1.92-.29A3.26 3.26 0 0 1 151 92a3.9 3.9 0 0 1-2 .51 5.81 5.81 0 0 1-2.21-.44 7.22 7.22 0 0 1-2-1.18q-5.16 4.13-10.25 8a50.87 50.87 0 0 0-9.22 9c-.49.3-.79.4-.89.3s-.44-.05-1 .15a31.72 31.72 0 0 1-3.47 6.12c-1.32 1.82-2.63 3.66-3.9 5.53a36.89 36.89 0 0 0-3.32 6 20 20 0 0 0-1.55 7.45 13.07 13.07 0 0 0 7 3 38.61 38.61 0 0 0 8.34.15q4.28-.36 8.55-1.1a44.79 44.79 0 0 1 7.67-.74c0-.89.39-1.33 1.18-1.33a29.77 29.77 0 0 0 11.51-3.47q5.31-2.86 11.06-5.82a10.94 10.94 0 0 1 1.92-3.1 6.19 6.19 0 0 0 1.33-3.83 9.11 9.11 0 0 1-1-2.22 11.61 11.61 0 0 1-.24-2.67z" />
                      <path class="cls-1"
                        d="M204.42 0H10.76A10.79 10.79 0 0 0 0 10.76v193.66a10.8 10.8 0 0 0 10.76 10.76h193.66a10.8 10.8 0 0 0 10.76-10.76V10.76A10.8 10.8 0 0 0 204.42 0zM85.17 90.85A15.35 15.35 0 0 0 83.4 94a24.48 24.48 0 0 1-1.85 2.28l-.81.82c-.19.49-.37.93-.51 1.32s-.32.89-.52 1.48l-.88 1.18a8.61 8.61 0 0 0-1.92 2.28c-.4.74-.84 1.6-1.33 2.59s-.84 1.79-1.33 2.72a11.27 11.27 0 0 1-2.06 2.73l.29 1.63-1.18 1a10.13 10.13 0 0 0-2.06 2.58c-.59 1-1.18 2.09-1.77 3.17s-1.23 2.36-1.92 3.54a14 14 0 0 1-2.65 3.25 36.93 36.93 0 0 1-1.85 4.13 19.24 19.24 0 0 1-2.73 3.54q-1.77 7.08-8.4 15.19a8.47 8.47 0 0 1-1 3.17 31.05 31.05 0 0 1-1.7 2.87q-.3.6-.66 1.26c-.25.44-.42.76-.52 1l-.44 1.62a13.28 13.28 0 0 1-1.8 2.65c-.65.69-1.26 1.33-1.85 1.92a3.75 3.75 0 0 0-.81.74c-.25.29-.47.54-.66.74l-2.51.88q-13-1.77-15.78-13.71l.14-1.63c.4-1.18.84-2.5 1.33-4q.73-2.5 1.62-4.94a11.16 11.16 0 0 1 2.95-4.35c.3-.89.86-2.24 1.7-4.06s2.24-4.55 4.2-8.18c1.58-2.86 2.83-5.12 3.77-6.79s1.69-3 2.28-3.83a21.75 21.75 0 0 0-4.13-5.17c-1.57-3-2.93-5.77-4-8.48a58.44 58.44 0 0 1-2.59-7.3 31.15 31.15 0 0 0-1.18-7.23c-.29-1.27-.59-2.55-.88-3.83a17.4 17.4 0 0 1-.44-4 11.52 11.52 0 0 1-1-2.66l.3-1.77a4.4 4.4 0 0 0 .37-3.17c-.25-1.33-.57-2.68-1-4.06s-.57-2.63-.81-4.05a17.14 17.14 0 0 1-.22-4.21 10.36 10.36 0 0 1 1.1-4 7.81 7.81 0 0 1 3.3-3.17l1.48-1 1.47.89A34.2 34.2 0 0 0 35 53.31l3 1.47c1.18.59 2.36 1.21 3.54 1.85S44 58 45.34 58.77l1.48 1-.15 1.62a2.41 2.41 0 0 0 .15.74 1.9 1.9 0 0 0 .44.74l1.62.44.12 2.09v1.77a7.67 7.67 0 0 0 .18 1.83 3.41 3.41 0 0 0 .59 1.1l.74 1.9a22.29 22.29 0 0 0 .49 4.76c.29 1.38.64 2.76 1 4.13a31.23 31.23 0 0 1 1.18 4.2 14.29 14.29 0 0 1 .15 4.65 6.83 6.83 0 0 0 1.77-1.33c.2-.19.42-.39.66-.59s.52-.39.81-.59l10.33-14-.3-1.77 3.69-3.54c1-.78 1.92-1.6 2.8-2.43a11.55 11.55 0 0 0 2.22-2.88l.88-1.33a27.46 27.46 0 0 1 17.09-10.92l2.51-.59.74 2.36a7.66 7.66 0 0 0 2.87 3.61c1.43 1 3 2 4.65 3l1.62 1a6.81 6.81 0 0 1 .89 2.65 6.13 6.13 0 0 1-.15 1.48l.74 1.92a17.09 17.09 0 0 1-3.54 6.21 52 52 0 0 1-4 3.46c-1.08.89-2.06 1.77-3 2.66a10 10 0 0 0-2.06 3l-1.18 1.47a8.87 8.87 0 0 0-4.72 5.61l-.59 2.06h-2.15c-.1-.08-.35.14-.74.59zm107.67 37.46a25.9 25.9 0 0 1-1.18 5.53 21.82 21.82 0 0 1-2.36 4.94 10.83 10.83 0 0 1-3.39 3.47A18 18 0 0 1 180 147a34.59 34.59 0 0 0-6.49 4.36 15.68 15.68 0 0 1-4.42 1.69c-1.58.35-3.2.72-4.87 1.11a31.85 31.85 0 0 1-4.57 2.28c-1.77.74-3.6 1.41-5.46 2a47.9 47.9 0 0 1-5.61 1.4 16.1 16.1 0 0 1-5 .22 53.08 53.08 0 0 1-10.33 2.65 33.27 33.27 0 0 1-11.8-.74 29 29 0 0 1-11.8-.59 28.72 28.72 0 0 1-9.51-4.57 32.22 32.22 0 0 1-7.23-7.37 43.46 43.46 0 0 1-4.91-9.11 48.3 48.3 0 0 1 .74-18.21A58.83 58.83 0 0 1 94.76 107a87.91 87.91 0 0 1 9.07-13q5.08-6 9.81-11.65a1.73 1.73 0 0 0 1.69 0 4.56 4.56 0 0 0 1.18-1.18 17 17 0 0 1 1.18-1.48 3.62 3.62 0 0 1 1.55-1 6.51 6.51 0 0 1 1.55-2.21 24.82 24.82 0 0 1 2.06-1.7 23.44 23.44 0 0 0 2.07-1.7 8.86 8.86 0 0 0 1.7-2.21 7.06 7.06 0 0 0 2.58-1 17.08 17.08 0 0 0 2.06-1.62 21.79 21.79 0 0 1 2-1.63 8.72 8.72 0 0 1 2.51-1.18v-1.95a13.25 13.25 0 0 0 4.72-3.25q1.51-1.77 3.51-4.57 1.62-.15 2.58-.15a25.16 25.16 0 0 0 3-.29 15.61 15.61 0 0 1 2.5-3.69 23 23 0 0 1 3.4-2.66 12.14 12.14 0 0 0 4.72 1.41 7.29 7.29 0 0 1 4.57 2.28 4.4 4.4 0 0 0 1 2.73 16.11 16.11 0 0 0 1.92 1.77c.68.54 1.37 1.11 2.06 1.7a4.15 4.15 0 0 1 1.33 2.5c.49 0 .81-.09 1-.29s.46-.25 1-.15a13.63 13.63 0 0 0 .59 1.92 7.85 7.85 0 0 0 .66 1.33c.25.39.49.83.74 1.32a11.83 11.83 0 0 1 .66 1.77 40.32 40.32 0 0 0-1.33 3.76 4 4 0 0 1-2.35 2.73c0 .79.29 1.21.88 1.26s.93.42 1 1.1a3.26 3.26 0 0 1-.44 2.22A139.93 139.93 0 0 1 181 92.76a123.09 123.09 0 0 0 7.67 14.53 10.27 10.27 0 0 0 .22 4.06 29 29 0 0 0 1.33 3.91c.54 1.28 1.06 2.56 1.55 3.83a18.86 18.86 0 0 1 1 3.84 24.17 24.17 0 0 1 .07 5.38z" />
                    </g>
                  </g>
                </svg>
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="'controls'">
              <div class="controls-container">
                <button class="btn btn-controls" *ngIf="component.data.showBack" (click)="onBack()"
                  [disabled]="!canGoBack()">
                  <i class="bx bx-arrow-back"></i>
                  <span class="visually-hidden">Back</span>
                </button>

                <button class="btn btn-controls" *ngIf="component.data.showInventory" (click)="onShowInventory()">
                  <i class="bx bxs-briefcase-alt-2"></i>
                  <span class="visually-hidden">Show Inventory</span>
                </button>

                <button class="btn btn-controls" *ngIf="component.data.showRestart"
                  (click)="onRestart(component?.data?.resetVarsOnRestart)">
                  <i class="bx bx-refresh"></i>
                  <span class="visually-hidden">Restart</span>
                </button>
                <button class="btn btn-controls" *ngIf="!fullscreen && component.data.showFullscreen">
                  <i class="bx bx-fullscreen" (click)="onOpenFullscreen()"></i>
                  <span class="visually-hidden">Open Fullscreen</span>
                </button>
                <button class="btn btn-controls" *ngIf="fullscreen && component.data.showFullscreen">
                  <i class="bx bx-exit-fullscreen" (click)="onCloseFullscreen()"></i>
                  <span class="visually-hidden">Close Fullscreen</span>
                </button>
                <button class="btn btn-controls" *ngIf="muted && component.data.showVolume">
                  <i class="bx bxs-volume-mute" (click)="onUnMute()"></i>
                  <span class="visually-hidden">Unmute</span>
                </button>
                <button class="btn btn-controls" *ngIf="!muted && component.data.showVolume">
                  <i class="bx bxs-volume-full" (click)="onMute()"></i>
                  <span class="visually-hidden">Mute</span>
                </button>

                <button class="btn btn-controls position-relative" [ngClass]="{'soundtrack-muted':soundtrackMuted}" *ngIf="component.data.showSoundtrack" (click)="onToggleSoundTrack()">
                  <i class="bx bxs-music"></i>
                  <span class="visually-hidden">Mute Soundtrack</span>
                </button>


                <button class="btn btn-controls position-relative" [ngClass]="{'captions-disabled':hideCaptions}" *ngIf="component.data.showCaptions"  (click)="onToggleCaptions()">
                  <i class="bx bxs-captions"></i>
                  <span class="visually-hidden">Mute Soundtrack</span>
                </button>
                
                <button class="btn btn-controls" *ngIf="component.data.showHelp" (click)="onShowHelp()">
                  <i class="bx bx-help-circle"></i>
                  <span class="visually-hidden">Help</span>
                </button>
                <button class="btn btn-controls" *ngIf="component.data.showClose" (click)="onClose()">
                  <i class="bx bx-x-circle"></i>
                  <span class="visually-hidden">Close</span>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>